import React from "react";

import "../App.css";

//import {  FormControl,  FormLabel,  FormHelperText,  FormErrorMessage,Input,RequiredIndicator} from "@vechaiui/react"
//import { VechaiProvider, Button } from "@vechaiui/react";
import {
  Grommet,
  Box,
  Button,
  Form,
  FormField,
  Text,
  Grid,
  TextInput,
  Image,
  Spinner,
} from "grommet";
//import logoImagen from "../assets/logoMatixDS.png";

import { Hide, View, User } from "grommet-icons";
import * as axios from "axios";
import FormRegister from "./FormRegister";
//import CarouselView from "./CarouselView";

class FormLogin extends React.Component {
  constructor(props) {
    super(props);
    //"http://127.0.0.1/webwassermaticvendinginnovation/index.php/apiViews/getListaBanners",
    this.state = {
      vistaActual: 0, //0 login  , 1 registro,
      urlLogin: "https://matixds.com:4530/webviewsapi/login",
      varUser: "",
      varPass: "",
      revealPass: false,
      dataLista: [],
      contGlobal: -1,
      currentFormURL: "https://matixds.com:4530/users/login",
      cssT_MOVIL: "",
      cssT_PASS: "",
      cssT_ACCESO: "",
      txtErrorMovil: "",
      txtErrorPass: "",
      txtErrorAcceso: "",
      btLoading: 0,
    };
    //crea referencias para identiificar los botones
    this.inputLoginDS = React.createRef();
    //bind de los eventois click
    /*
    this.fnClickAddProducto = this.fnClickAddProducto.bind(this);
    this.fnCambio = this.fnCambio.bind(this);
    this.fnCambioBack = this.fnCambioBack.bind(this);
    this.fnVerVideo = this.fnVerVideo.bind(this);

    this.fnCerrarVideo = this.fnCerrarVideo.bind(this);
    */
  }

  parentMethodLogin(data) {
    //alert("REGRESO" + data);
    this.setState({ vistaActual: 0 });
  }

  fnClickAddProducto() {
    // alert("Clicked Button");
    this.setState({ vistaActual: 1 });
  }

  componentDidMount() {
    // this.fnLista();
    //  alert("hola");
    // setInterval(() => {
    //   console.log('Interval triggered');
    // }, 1000);
  }

  async fnLogin() {
    //obtiene sucursales para variable global
    axios
      .request({
        method: "post",
        url: this.state.urlLogin,
        data: {
          login: this.state.varUser,
          password: this.state.varPass,
        },
        onUploadProgress: (p) => {
         // console.log("Login " + p);          
        },
      })
      .then(
        (response) => {
          //JSON.stringify(response)
          //alert(JSON.stringify(response.data.valStatus));
          if (response.data.valStatus == "OK") {
            this.setState({ btLoading: 1 });
            this.inputLoginDS.current.click(); //ENVIA FORMULARIIO POST
          } else {
            this.setState({ btLoading: 0 });
            this.setState({ txtErrorAcceso: response.data.valStatus });
            this.setState({ cssT_ACCESO: "divError" });
          }
          
          //regresa a su componente parent
        },
        (error) => {
          console.log(error);
        }
      );
  }

  fnValidarFormulario() {
    // this.setState({FormErrors:""});

    var frmListo = 1;
    var cadenaErrores = "";

    this.setState({ cssT_MOVIL: "" });
    this.setState({ cssT_PASS: "" });

    if (this.state.varUser.length <= 0) {
      cadenaErrores = cadenaErrores + "\n" + "  Escriba su nombre de usuario";
      this.setState({ cssT_MOVIL: "txtError" });
      frmListo = 0;
      //this.nameInput.focus();
    }
    if (this.state.varPass.length == 0) {
      cadenaErrores = cadenaErrores + " Escriba una contraseña";
      this.setState({ cssT_PASS: "txtError" });
      frmListo = 0;
    }

    if (frmListo == 0) {
      //   this.setState({ cssError: "divError" });
      //   this.setState({
      //     FormErrors: cadenaErrores,
      //   });
    }
    return frmListo;
  }

  render() {
    let contenidos = <div></div>;
    let contRegistro = (
      <div>
        <FormRegister parentReference={this.parentMethodLogin.bind(this)} />
      </div>
    );
    let conBtAcces = (
      <div>
        <br />
        <Button
          label="Acceder"
          primary
          onClick={() => {
            //alert(this.state.varUser);
            // alert(this.state.varPass);
            // this.inputLoginDS.current.click(); //ENVIA FORMULARIIO POST
            this.setState({ txtErrorAcceso: "" });
            this.setState({ cssT_ACCESO: "" });
            var resValida = this.fnValidarFormulario();
            if (resValida == 1) {
              this.setState({ btLoading: 1 });
              this.fnLogin();
            }
          }}
        />
      </div>
    );

    let conBtspin = (
      <div align="center">
        <Spinner />
      </div>
    );
    let contBTAcceder = <div></div>;
    if (this.state.btLoading == 1) {
      contBTAcceder = conBtspin;
    } else {
      contBTAcceder = conBtAcces;
    }

    let contLogin = (
      <div>
        <Grid
          rows={["xxsmall", "medium", "xsmall"]}
          columns={["1/4", "3/4"]}
          areas={[["sidebar", "main"]]}
          gap="small"
        >
          <Box background="light-5" gridArea="sidebar">
            <img src="https://matixds.com/assets/images/servicioMatixTVMobimatix.jpg" />
          </Box>

          <Box gridArea="main" align="center">
            <div className="divRound">
              <div className="divTxtTitulo">
                <User size="medium" />
                Acceder a tu cuenta
              </div>

              <div className="divTxtSmall2x">
                <div className={this.state.cssT_MOVIL}>
                  Teléfono móvil ó correo electrónico
                </div>
              </div>
              <TextInput
                placeholder="Teléfono móvil ó correo electrónico"
                textAlign={"center"}
                onChange={(e) => this.setState({ varUser: e.target.value })}
              />
              <br />
              <div className="divTxtSmall2x">
                <div className={this.state.cssT_PASS}>
                  Contraseña
                  <Button
                    icon={
                      this.state.revealPass ? (
                        <View size="medium" />
                      ) : (
                        <Hide size="medium" />
                      )
                    }
                    onClick={() =>
                      this.setState({ revealPass: !this.state.revealPass })
                    }
                  />
                </div>
              </div>
              <TextInput
                textAlign={"center"}
                placeholder="Contraseña"
                type={this.state.revealPass ? "text" : "password"}
                value={this.state.varPass}
                onChange={(event) =>
                  this.setState({ varPass: event.target.value })
                }
              />
              <br />
              <div className={this.state.cssT_ACCESO}>
                {this.state.txtErrorAcceso}
              </div>
              {contBTAcceder}
              <br />
              <div className="divTxtSmall3x">
                No tienes cuenta?{" "}
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    this.setState({ vistaActual: 1 });
                  }}
                >
                  Regístrate
                </a>
                <br />
                <br />
                <a
                  href="https://matixds.com/index.php/home/politicasPrivacidad"
                  target={"_blank"}
                >
                  Políticas de privacidad
                </a>{" "}
                y{" "}
                
                <a
                  href="https://matixds.com/index.php/home/terminosServicio"
                  target={"_blank"}
                >
                  Términos del servicio
                </a>
              </div>
            </div>
          </Box>
        </Grid>
        <form
          method="post"
          action={this.state.currentFormURL}
          style={{ display: "none" }}
        >
          <input type="text" name="login" value={this.state.varUser} />
          <input type="text" name="password" value={this.state.varPass} />
          <input type="submit" value="Submit" ref={this.inputLoginDS} />
        </form>
      </div>
    );

    if (this.state.vistaActual == 0) {
      contenidos = contLogin;
    }
    if (this.state.vistaActual == 1) {
      contenidos = contRegistro;
    }
    return <Grommet>{contenidos}</Grommet>;
  }
}
export default FormLogin;
